import DownloadIcon from "@mui/icons-material/Download";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from "react-router-dom";
import MDButton from "../../components/MDButton";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";

let filesContent;

const ConcreteResultAdd = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [document, setDocument] = useState({
    url: null,
    file: null,
    date: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [fieldErrors, setFieldErrors] = useState({
    file: false,
    date: false
  });
  const [withdrawalOptions, setWithdrawalOptions] = useState([]);
  const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
  const [cubesOptions, setCubesOptions] = useState([]);
  const [selectedCube, setSelectedCube] = useState(null);

  useEffect(() => {
    if (id) {
      fetchDocument(id);
    }
  }, [id]);

  function fetchWithdrawalOptions() {
    apiService.get('/concrete-casting-registration-managment/get-option/', {id_area: localStorage.getItem("areaSelected")}, {})
        .then((response) => {
          if (response)
            setWithdrawalOptions(response)
        })
        .catch((error) => {
          toast.error('Errore durante la chiamata al server, codice d\'errore #08514262429906', {id: 'concrete-result-add-toast'});
        })
  }

  function fetchCubeOptions() {
    if (!selectedWithdrawal) {
      apiService.get('/concrete-cubes/get-option/', {}, {})
        .then((response) => {
          if (response)
            setCubesOptions(response)
        })
        .catch((error) => {
          toast.error('Errore durante la chiamata al server, codice d\'errore #08514262429906', {id: 'concrete-result-add-toast'});
        })
    }
    else {
      apiService.get('/concrete-cubes/get-option/', {id_casting: selectedWithdrawal.id}, {})
        .then((response) => {
          if (response)
            setCubesOptions(response)
        })
        .catch((error) => {
          toast.error('Errore durante la chiamata al server, codice d\'errore #08514262429906', {id: 'concrete-result-add-toast'});
        })
    }
  }

  useEffect(() => {
    fetchWithdrawalOptions();
  }, []);

  useEffect(() => {
      fetchCubeOptions();
  }, [selectedWithdrawal]);

  const fetchDocument = async (docId) => {
    setLoading(true);
     apiService.get("/concrete-result/",{id_document: id} ,{} )
      .then((response) => {
        if (response) {
          const cube = response.cube
          const withdrawal = response.withdrawal
          setSelectedWithdrawal(withdrawal)
          setSelectedCube(cube)
          delete response.withdrawal
          delete response.cube
          setDocument(response)
        }
      })
      .catch((error) => {
        toast.error('Errore durante la chiamata al server, codice d\'errore #08514262429906', {id: 'concrete-result-add-toast'});
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFileChange = (event) => {
    if (!event.target.files) return;

    const filePromise = new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const fileObj = {
          name: event.target.files[0].name,
          type: event.target.files[0].type,
          size: event.target.files[0].size,
          modified: event.target.files[0].lastModified,
          content: null
        };
        const contentObj = reader.result;

        filesContent = contentObj;

        resolve(fileObj);
      };
      reader.readAsDataURL(event.target.files[0]);
    });

    Promise.resolve(filePromise).then((processedFile) => {
      setDocument((prevDoc) => ({ ...prevDoc, file: processedFile, url: null }));
      setFieldErrors((prevErrors) => ({ ...prevErrors, file: false }));
    });
  };

  const handleInputChange = (name, value) => {
    setDocument((prevDoc) => ({ ...prevDoc, [name]: value }));
    setFieldErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
  };

  const handleSave = async () => {
    const errors = {
      file: !document.file && !document.url,
      date: !document.date,
      cube: !selectedCube
    };

    setFieldErrors(errors);

    if (Object.values(errors).some(Boolean)) {
      toast.error('Per salvare il verbale devi inserire tutti i campi', {id: 'concrete-result-add-toast'});
      return;
    }

    setLoading(true);
    let documentToSave = JSON.parse(JSON.stringify(document));
    if (document.file) {
      documentToSave.file.content = filesContent;
    }
    let data = null
    if (id) {
      data = {area_id: localStorage.getItem("areaSelected"), document: documentToSave, id: id, concrete_cubes_id: selectedCube.concrete_cubes_id}
    }else{
      data = {area_id: localStorage.getItem("areaSelected"), document: documentToSave, concrete_cubes_id: selectedCube.id}
    }
    apiService.post("/concrete-result/", {},data )
      .then((response) => {
        toast.success('Risultato salvato con successo', {id: 'concrete-result-add-toast'});
        navigate("/concrete-result-managment/");
      })
      .catch((error) => {
        toast.error('Errore durante la chiamata al server, codice d\'errore #08514262429906', {id: 'concrete-result-add-toast'});
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = () => {
    if (document.url) {
      window.open(document.url, '_blank');
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
        {!loading ?
          <>
            <center>
              <MDButton onClick={() => navigate("/concrete-result-managment/")}>Torna alla tabella</MDButton>
            </center>
          <Paper elevation={3} sx={{p: 3, maxWidth: 500, mx: 'auto', mt: 4}}>
            <Typography variant="h5" gutterBottom>
              {id ? 'Modifica il risultato' : 'Aggiungi un risultato'}
            </Typography>
            <Box component="form" noValidate autoComplete="off" sx={{mt: 2}}>
              <Box sx={{mb: 2}}>
                <input
                  accept="*/*"
                  style={{display: 'none'}}
                  id="raised-button-file"
                  type="file"
                  onChange={handleFileChange}
                />
                <label htmlFor="raised-button-file">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{
                      color: 'white!important',
                      borderColor: fieldErrors.file ? 'red' : 'primary.main',
                      '&:hover': {
                        borderColor: fieldErrors.file ? 'red' : 'primary.dark',
                      },
                    }}
                  >
                    {document.file || document.url ? 'Cambia file' : 'Carica file'}
                  </Button>
                </label>
                {(document.file || document.url) && (
                  <Typography variant="body2" sx={{mt: 1}}>
                    {document.file ? document.file.name : 'File già caricato'}
                  </Typography>
                )}
                {(id && document.file) || document.url ? (
                  <Button
                    startIcon={<DownloadIcon/>}
                    variant="contained"
                    color="primary"
                    sx={{
                      marginBottom: "30px",
                      color: 'white!important',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }} onClick={handleDownload}
                  >
                    Scarica
                  </Button>
                ) : null}
                {fieldErrors.file && (
                  <Typography color="error" variant="caption" sx={{mt: 1, display: 'block'}}>
                    File is required
                  </Typography>
                )}
              </Box>

              <Autocomplete
                options={withdrawalOptions}
                value={selectedWithdrawal}
                onChange={(event, newValue) => {
                  setSelectedWithdrawal(newValue);
                }}
                getOptionLabel={(option) => option.name || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    label={"Filtra per getti"}
                    sx={{mb: 2}}
                    />
                )}
              />

              <Autocomplete
                options={cubesOptions}
                value={selectedCube}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setFieldErrors((prevErrors) => ({ ...prevErrors, cube: false }));
                  }
                  setSelectedCube(newValue)
                }}
                getOptionLabel={(option) => option.name || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    error={fieldErrors.cube}
                    label={"Seleziona un cubo *"}
                    sx={{mb: 2}}
                    />
                )}
              />

              <DatePicker
                label="Data *"
                value={document.date ? dayjs(document.date) : null}
                sx={{color: fieldErrors.date ? 'red' : 'inherit', borderColor: fieldErrors.date ? 'red' : 'inherit'}}
                onChange={(newValue) => {
                  const formattedDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : null;
                  handleInputChange('date', formattedDate);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    name="date"
                    sx={{mb: 2}}
                    required
                    error={fieldErrors.date}
                    helperText={fieldErrors.date ? 'Date is required' : ''}
                  />
                )}
                inputFormat="DD-MM-YYYY"
              />

              <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 2,}}>
                <Button sx={{color: 'white!important'}} variant="contained" onClick={handleSave} disabled={loading}>
                  Salva
                </Button>
              </Box>
            </Box>
            {error && (
              <Typography color="error" sx={{mt: 2}}>
                {error}
              </Typography>
            )}
          </Paper>
          </>
          :
          <center>
            <CircularProgress size={120} sx={{marginTop: "250px", color: "#2b84ea"}}/>
          </center>
        }
      </LocalizationProvider>
    </DashboardLayout>

  );
};

export default ConcreteResultAdd;